import { defineMessages } from 'react-intl';

export default defineMessages({
  description: {
    id: 'CourseDetailsContent.ConfirmDeleteDescription.description',
    defaultMessage: 'All related data will be deleted also',
  },
  favoriteCourses: {
    id: 'CourseDetailsContent.ConfirmDeleteDescription.favoriteCourses',
    defaultMessage: 'Favorite courses ({count}):',
  },
  discussions: {
    id: 'CourseDetailsContent.ConfirmDeleteDescription.discussions',
    defaultMessage: 'Discussions ({count}):',
  },
  userCourses: {
    id: 'CourseDetailsContent.ConfirmDeleteDescription.userCourses',
    defaultMessage: 'Course progress of users ({count}):',
  },
  userCoursesSubtitle: {
    id: 'CourseDetailsContent.ConfirmDeleteDescription.userCoursesSubtitle',
    defaultMessage:
      'Including related to these lessons that are attached in another courses',
  },
  videoNotes: {
    id: 'CourseDetailsContent.ConfirmDeleteDescription.videoNotes',
    defaultMessage: 'Video notes ({count}):',
  },
  textNotes: {
    id: 'CourseDetailsContent.ConfirmDeleteDescription.textNotes',
    defaultMessage: 'Text notes ({count}):',
  },
  tasks: {
    id: 'CourseDetailsContent.ConfirmDeleteDescription.tasks',
    defaultMessage: 'Tasks ({count}):',
  },
  assignees: {
    id: 'CourseDetailsContent.ConfirmDeleteDescription.assignees',
    defaultMessage: 'Assignees ({count}):',
  },
});
